import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';

function App() {

    const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");

    const [routeData, setRouteData] = useState('');
    const [inputData, setinputData] = useState('');
    const [zoneData, setZoneData] = useState('');
    const [routeFilter, setRouteFilter] = useState('');

    const getData = async () => {
        try {
            const zones = await axios.get('https://api.trucoo.in/zone/', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(zones.data);
            if(zones.data.status === 'success'){
                setZoneData(zones.data.data);
            }
            const routes = await axios.post('https://api.trucoo.in/routes/view/',{}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(routes.data.status === 'success'){
                setRouteData(routes.data.routes);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };


    useEffect(() => {
        getData();
    },[userID]);

    const newData = (e) => {
        const { name, value } = e.target;
        setinputData((prevData) => ({
          ...prevData,
          [name]: value,
		  ['userId']: userID
        }));
    };

    const addRoute = async() => {
        const sendData = {
            route: inputData.route,
            zone: inputData.zoneid,
            type: 'route'
        }
        try {
            const response = await axios.post('https://api.trucoo.in/routes/add/', sendData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                getData();
                alert(response.data.msg);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const addLocation = async() => {
        const sendData = {
            route: inputData.routeid,
            location: inputData.location,
            type: 'location'
        }
        try {
            const response = await axios.post('https://api.trucoo.in/routes/add/', sendData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                getData();
                alert(response.data.msg);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const addZone = async() => {
        const sendData = {
            zone: inputData.zone,
            type: 'zone'
        }
        try {
            const response = await axios.post('https://api.trucoo.in/zone/', sendData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            //console.log(response.data);
            if(response.data.status === 'success'){
                getData();
                alert(response.data.msg);
            }
        }catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const routeFilterData = (e) => {
        const { name, value } = e.target;
        setinputData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        if(value !== ''){
            const filteredRoutes = routeData.filter(route => route.zoneId === value);
            setRouteFilter(filteredRoutes);
        } else {
            getData();
        }
    };

    console.log(routeData);

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
        <div class="container-full">
        
            <section class="content">
            <div class="box">
                <div class="box-header with-border">
                  <h4 class="box-title">Route Data</h4>
                  <p class="mb-0 box-subtitle">Routes & Locations</p>
                </div>
                <div class="box-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
								<label class="form-label">Zone</label>
								<input type="text" class="form-control" name="zone" placeholder='Enter Zone...' value={inputData.zone} onChange={(e)=>newData(e)} required />
							</div>
                        </div>
                        <div class="col-md-2 mt-2">
                            <div class="form-group">
								<button class="btn btn-sm btn-success mt-4" onClick={addZone}> Add Zone</button>
							</div>
                        </div>
                    </div>

                    
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
								<label class="form-label">Select Zone</label>
								<select class="form-select" name="zoneid" value={inputData.zoneid} onChange={(e)=>newData(e)} >
                                    <option value="" hidden>Select a Zone</option>
                                {zoneData && zoneData?.map(data=>
                                    <option value={data.id}>{data.zone}</option>
                                )}
                                </select>
							</div>
                        </div>
                         <div class="col-md-3">
                            <div class="form-group">
								<label class="form-label">Route</label>
								<input type="text" class="form-control" name="route" placeholder='Enter Route...' value={inputData.route} onChange={(e)=>newData(e)} required />
							</div>
                        </div>
                        <div class="col-md-2 mt-2">
                            <div class="form-group">
								<button class="btn btn-sm btn-success mt-4" onClick={addRoute}> Add Route</button>
							</div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
								<label class="form-label">Select Zone</label>
								<select class="form-select" name="zones" value={inputData.zones} onChange={(e)=>routeFilterData(e)} >
                                    <option value="" hidden>Select a Zone</option>
                                {zoneData && zoneData?.map(data=>
                                    <option value={data.id}>{data.zone}</option>
                                )}
                                </select>
							</div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
								<label class="form-label">Select Route</label>
								<select class="form-select" name="routeid" value={inputData.routeid} onChange={(e)=>newData(e)} >
                                    <option value="" hidden>Select a Route</option>
                                {routeFilter && routeFilter?.map(data=>
                                    <option value={data.id}>{data.route}</option>
                                )}
                                </select>
							</div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
								<label class="form-label">Place</label>
								<input type="text" class="form-control" name="location" placeholder='Enter Location...' value={inputData.location} onChange={(e)=>newData(e)} required />
							</div>
                        </div>
                        <div class="col-md-2 mt-2">
                            <div class="form-group">
								<button class="btn btn-sm btn-success mt-4" onClick={addLocation}> Add Place</button>
							</div>
                        </div>

                    </div>
                </div>
              </div>
            </section>
        </div>
    </div>

    <Footer />
</>
);
}

export default App;